var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8351 13H16.2C15.0799 13 14.5198 13 14.092 13.218C13.7157 13.4097 13.4097 13.7157 13.218 14.092C13 14.5198 13 15.0799 13 16.2V18.9288M19 11.7277V6.2C19 5.0799 19 4.51984 18.782 4.09202C18.5903 3.71569 18.2843 3.40973 17.908 3.21799C17.4802 3 16.9201 3 15.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.0799 19 6.2 19H11.954C12.4624 19 12.7166 19 12.9548 18.9407C13.1659 18.8881 13.367 18.8014 13.5501 18.684C13.7568 18.5517 13.9313 18.3668 14.2804 17.9972L18.1264 13.9249C18.4492 13.5832 18.6106 13.4123 18.7258 13.2155C18.828 13.041 18.9032 12.8521 18.9487 12.6551C19 12.4329 19 12.1978 19 11.7277Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberblack);
export default __webpack_public_path__ + "static/media/subscriberblack.152e0ac57992792c28c2ff341cb6fc45.svg";
export { ForwardRef as ReactComponent };